<template>
  <div class="editor">
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      :disabled="disabled"
      @blur="onEditorBlur"
      @change="onEditorChange"
    ></quill-editor>
    <el-upload
      class="upload"
      ref="upload"
      action="https://up-z2.qiniup.com"
      :data="uploadData"
      :before-upload="beforeUpload"
      :on-success="upScuccess"
      style="display:none;"
    >
      <el-button
        id="imgInput"
        size="small"
        type="primary"
        v-loading.fullscreen.lock="fullscreenLoading"
        element-loading-text="插入中,请稍候"
      >点击上传</el-button>
    </el-upload>
  </div>
</template>

<script>
/* eslint-disable */
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill';
import { quillEditor } from 'vue-quill-editor';
import { getQiNiuYunToken } from '@/api/common';
let fontSizeStyle = Quill.import('attributors/style/size')
fontSizeStyle.whitelist = ['12px', '14px', '16px','18px', '20px','22px', '24px', '32px']
Quill.register(fontSizeStyle, true)
/* eslint-enable */

export default {
  name: 'Editor',
  components: {
    quillEditor,
  },
  data() {
    return {
      content: '', // 文章内容
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: fontSizeStyle.whitelist }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }], // 这里是传入的字体配置
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'video'],
          ],
        },
      },
      domain: '',
      uploadData: {},
      uploadType: '', // 上传的文件类型（图片、视频）
      addRange: [],
      fullscreenLoading: false,
      lockImageUpload: false, // 上传图片功能 允许/禁止 锁
      lockVideoUpload: true, // 上传视频功能 允许/禁止 锁
    };
  },
  props: {
    // 文章内容
    editContent: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    editContent: {
      handler(value) {
        if (this.content !== value) {
          this.content = value;
        }
      },
      immediate: true,
    },
  },
  computed: {
    myQuillEditor() {
      return this.$refs.myQuillEditor;
    },
    upload() {
      return this.$refs.upload;
    },
  },
  mounted() {
    // 为图片ICON绑定事件  getModule 为编辑器的内部属性
    this.myQuillEditor.quill
      .getModule('toolbar')
      .addHandler('image', this.imgHandler);
    // 为视频ICON绑定事件
    this.myQuillEditor.quill
      .getModule('toolbar')
      .addHandler('video', this.videoHandler);
  },
  methods: {
    beforeUpload(file) {
      return this.qnUpload(file);
    },
    // 图片上传前获得数据token数据
    qnUpload(file) {
      const suffix = file.name.split('.');
      const ext = suffix.splice(suffix.length - 1, 1)[0];
      this.fullscreenLoading = true;

      // 如果是点击插入图片
      if (this.uploadType === 'image') {
        return getQiNiuYunToken().then((res) => {
          const { token, domain } = res.data;

          this.uploadData = {
            key: `image/${suffix.join('.')}_${new Date().getTime()}.${ext}`,
            token,
          };
          this.domain = domain;
        });
      }

      // 如果是点击插入视频
      if (this.uploadType === 'video') {
        return getQiNiuYunToken().then((res) => {
          const { token, domain } = res.data;

          this.uploadData = {
            key: `video/${suffix.join('.')}_${new Date().getTime()}.${ext}`,
            token,
          };
          this.domain = domain;
        });
      }
      return false;
    },
    // 图片上传成功回调   插入到编辑器中
    upScuccess(e) {
      let url = '';
      const vm = this;
      this.fullscreenLoading = false;

      if (this.uploadType === 'image') {
        // 获得文件上传后的URL地址
        url = this.domain + e.key;
      } else if (this.uploadType === 'video') {
        url = this.domain + e.key;
      }

      if (url != null && url.length > 0) {
        let value = url;
        // 获取光标位置对象，里面有两个属性，一个是index 还有 一个length，这里要用range.index，
        // 即当前光标之前的内容长度，然后再利用 insertEmbed(length, 'image', imageUrl)，插入图片即可。
        vm.addRange = vm.myQuillEditor.quill.getSelection();
        value = value.indexOf('http') !== -1 ? value : `http:${value}`;

        // 调用编辑器的 insertEmbed 方法，插入URL
        vm.myQuillEditor.quill.insertEmbed(
          vm.addRange !== null ? vm.addRange.index : 0,
          vm.uploadType,
          value,
          Quill.sources.USER,
        );
        vm.myQuillEditor.quill.setSelection(vm.addRange.index + 1);
      } else {
        this.$message.error(`${vm.uploadType}插入失败`);
      }
      // 插入成功后清除input的内容
      this.upload.clearFiles();
    },
    // 点击图片ICON触发事件
    imgHandler(state) {
      if (this.lockImageUpload) {
        this.$message.warning('暂未开放图片上传功能！');
      } else {
        this.addRange = this.myQuillEditor.quill.getSelection();

        if (state) {
          const fileInput = document.getElementById('imgInput');
          fileInput.click(); // 加一个触发事件
        }
        this.uploadType = 'image';
      }
    },
    // 点击视频ICON触发事件
    videoHandler(state) {
      if (this.lockVideoUpload) {
        this.$message.warning('暂未开放视频上传功能！');
      } else {
        this.addRange = this.myQuillEditor.quill.getSelection();

        if (state) {
          const fileInput = document.getElementById('imgInput');
          fileInput.click(); // 加一个触发事件
        }
        this.uploadType = 'video';
      }
    },
    onEditorBlur() {
      this.$emit('getValue', this.content);
    },
    onEditorChange() {
      this.$emit('getValue', this.content);
    },
    clearContent() {
      this.content = '';
    },
  },
};
</script>

<style lang="stylus">
.editor
  .quill-editor
    min-height 300px
    max-width 800px
    .ql-container
      height auto
      min-height 300px
  .ql-snow .ql-editor img
    max-width 100%
  .ql-editor .ql-video
    max-width 100%
    min-height 300px
.ql-snow .ql-picker
  line-height 24px
  span
    outline none!important
.ql-snow .ql-tooltip.ql-editing a.ql-action::after
  content '保存'
.ql-snow .ql-tooltip[data-mode=link]::before
  content '链接地址'
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before
  content '12px'
  font-size 12px
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before
  content '14px'
  font-size 14px
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before
  content '16px'
  font-size 16px
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before
  content '18px'
  font-size 18px
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before
  content '20px'
  font-size 20px
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before
  content '22px'
  font-size 22px
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before
  content '24px'
  font-size 24px
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before
  content '32px'
  font-size 32px
.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before
  content '文本'
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before
  content '标题1'
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before
  content '标题2'
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before
  content '标题3'
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before
  content '标题4'
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before
  content '标题5'
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before
  content '标题6'
.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before
  content '标准字体'
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before
  content '衬线字体'
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before
  content '等宽字体'
</style>
